<template>
  <!-- Shared wordmark: its violet brand colour must not follow page accents. -->
  <span class="gonkagame-logo" aria-label="GonkaGame">
    <span class="gonkagame-logo__word">Gonka</span><span class="gonkagame-logo__accent">Game</span>
  </span>
</template>

<style scoped lang="scss">
.gonkagame-logo {
  display: inline-flex;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: var(--p-font-display);
  font-weight: var(--ds-weight-bold);
  font-size: var(--p-text-22);
  letter-spacing: -0.02em;
  line-height: 1;
  white-space: nowrap;
  user-select: none;

  &__word {
    color: var(--ds-text);
  }

  &__accent {
    color: var(--ds-brand-accent);
  }
}
</style>
